import React from "react";

const NoteCard = ({ id, imageUrl, title, format, articleUrl, videoUrl }) => {
  const url = articleUrl || videoUrl;
    return (
        <a key={id} href={url} className="note-card" target="_blank" rel="noopener noreferrer"> 
        <img src={imageUrl} alt={title} className="note-image" />
        <h2 className="note-format">{format}</h2>
        <h3 className="note-title">{title}</h3>
        {/* <h5 className="note-title2">today i am going outside</h5> */}
      </a>
    );
  };

  export default NoteCard;